import { createContext, useContext, useContextSelector, } from 'use-context-selector';
export const TableContext = createContext({
    selected: [],
    selectable: false,
    selectableValues: new Set(),
    allSelected: false,
    tableRef: { current: null },
    onSelect: () => void 0,
    onSelectAll: () => void 0,
    hadKeyboardEvent: false,
});
export const useTableContext = () => useContext(TableContext);
export const useTableContextSelector = (selector) => useContextSelector(TableContext, selector);
//# sourceMappingURL=TableContext.js.map